import React, { FC } from 'react';

import { styled } from '../../theme';

const AccordionDetailsWrapper = styled('div')<{ style?: React.CSSProperties }>(
    ({ theme, style = {} }) => ({
        padding: 10,
        ...style,
    })
);

type Props = {
    style?: React.CSSProperties;
};

const AccordionDetails: FC<Props> = ({ children, style }) => {
    return <AccordionDetailsWrapper style={style}>{children}</AccordionDetailsWrapper>;
};

export default AccordionDetails;
